var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress_indicator"},[_c('span',[_vm._v("Decoding...")]),(_vm.percentage < 99.99999 && _vm.percentage > 0)?_c('span',[_vm._v(" "+_vm._s(_vm.percentage)+" % ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }